import { createSlice } from "@reduxjs/toolkit";

const requirementsSlice = createSlice({
  name: "requirements",
  initialState: [],
  reducers: {
    requirementsAdded(state, action) {
      return action.payload;
    },
  },
});

export const { requirementsAdded } = requirementsSlice.actions;
export default requirementsSlice.reducer;
